import { render, staticRenderFns } from "./ResponseTimeChart.vue?vue&type=template&id=5c822009"
import script from "./ResponseTimeChart.vue?vue&type=script&lang=js"
export * from "./ResponseTimeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports